module.exports = __webpack_public_path__ + "img/AirplanemodeActiveOutlined.bc8144dc.svg";